import { FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@material-ui/core';
import React, { useState, useEffect, useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Message from '../../../elements/message';
import Loading from '../../../helper/screens/Loading';
import TopBar from '../../../elements/topbar';
import { translate } from '../../../helper/multilingual';
import { getUserToken, hasPermission } from '../../../helper/functions/auth';
import ProductUnit from '../../../communicator/http/Products';
import BankingUnit from '../../../communicator/http/Banking';
import Pagination from '../../../elements/pagination';
import wrlog from '../../../helper/functions/wrlog';
import { formatDbDate } from '../../../helper/functions/formatDate';
import { Autocomplete } from '@material-ui/lab';
import StatusLabel from '../../../elements/statusLabel';
import ToolTip from '../../../elements/tooltip';
import Cache from '../../../communicator/local';
import DatePicker from '../../../elements/datepicker';
import { formatMoney } from '../../../helper/functions/formatPrice';
import { translateTransactionStatus, translatePaymentType } from '../../../helper/functions/translateTransaction';
import Popup from '../../../elements/popup';
import InvoiceUnit from '../../../communicator/http/Invoices';
import Unit from '../../../communicator/http';
import Dropzone from 'react-dropzone';

import balanceStyles from '../Balance/style.module.scss';
import styles from './style.module.scss';
import BankingOrderUnit from '../../../communicator/http/BankingOrder';
import ProcurementSupplierUnit from '../../../communicator/http/ProcurementSupplier';
import { Link } from 'react-router-dom';


/**
 * 
 * @returns Transactions Overview Page
 */
const BankingOrders = (props) => {

    const [loading, setLoading] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);

    const [orders, setOrders] = useState([]);
    const [filterSupplier, setFilterSupplier] = useState('');
    const [suppliers, setSuppliers] = useState([]);
    const [filterStatus, setFilterStatus] = useState('');

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isInit, setIsInit] = useState(true);
    const [orderSum, setOrderSum] = useState(0);

    const [errorMessageOpen, setErrorMessageOpen] = useState(false);
    const [errorMessageType, setErrorMessageType] = useState('error');
    const [errorMessageTitle, setErrorMessageTitle] = useState("");
    const [errorMessageBody, setErrorMessageBody] = useState("");
    const [errorMessageButtonText, setErrorMessageButtonText] = useState("OK");
    const [errorMessageSmall, setErrorMessageSmall] = useState(true);

    const perPage = 25;

    const bankingOrderUnit = new BankingOrderUnit();
    const supplierUnit = new ProcurementSupplierUnit();

    const queryArgsCache = new Cache('bankingOrders.queryArgs', true);

    /**
     * initially loads products
     */
    useEffect(() => {

        let queryArgs = queryArgsCache.get();

        if (queryArgs !== false) {
            if (queryArgs.supplier !== undefined && props.supplier === undefined) {
                setFilterSupplier(queryArgs.supplier);
            }
            if (queryArgs.status !== undefined && props.status === undefined) {
                setFilterStatus(queryArgs.status);
            }

            setPage(queryArgs.page);
        }

        supplierUnit.list('', res => {
            setSuppliers(res.results);
        }, err => {

        })

    }, []);


    /**
     * initially loads products
     */
    useEffect(() => {
        let queryArgs = queryArgsCache.get();
        if (page > 0 && (!isInit || queryArgs === false)) {
            setIsInit(false);
            load();
        }
    }, [page]);

    useEffect(() => {
        setIsInit(false);
        setLoading(true);
        setPage(0);
        setTimeout(() => {
            setPage(1);
        }, 100)
    }, [filterSupplier, filterStatus]);

    /**
* loads products by search result
* @param {*} e 
*/
    const doSearch = (e) => {
        e.preventDefault();
        load();
    }


    /**
     * Loads transactions from API
     */
    const load = (cb = () => { }) => {

        setLoading(true);

        const skip = (page - 1) * perPage;

        const body = {
            skip: skip,
            take: perPage,
            supplier: filterSupplier,
            status: filterStatus,
        };

        bankingOrderUnit.list(body, (res) => {

            setLoading(false);
            setOrders(res.results);
            setOrderSum(res.sumOpen);
            setTotalPages(Math.ceil(res.total / perPage));
            cb();
            body.page = page;
            queryArgsCache.set(body);

        }, (err) => {
            setLoading(false);
        })
    }

    const updateOrderStatus = (id, status) => {

        let index = orders.findIndex(o => o.id === id);

        let _orders = [...orders];
        _orders[index]['status'] = status;

        setOrders(_orders);

        let body = {
            id: id,
            status: status
        }

        bankingOrderUnit.update(body, (res) => {
        }, (err) => {
        })
    }

    return <>
        <TopBar title={"Aufträge"} />
        <Container fluid>
            <Row style={{ marginTop: 44 }}>
                <Col md={12}>
                    <Row>
                        <Col md={6}>
                            <form onSubmit={doSearch}>
                                <FormControl
                                    className="selectFormControl"
                                >
                                    <InputLabel id="type">Lieferanten</InputLabel>
                                    <Select
                                        onChange={(e) => {
                                            setFilterSupplier(e.target.value === '' ? '' : e.target.value)
                                        }}
                                        value={filterStatus || ""}
                                    >
                                        <MenuItem value={""}>Alle</MenuItem>
                                        {
                                            suppliers.map(su => (
                                                <MenuItem value={su.id}>{su.companyTitle}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>                            </form>
                        </Col>
                        <Col md={3}>
                            <FormControl
                                className="selectFormControl"
                            >
                                <InputLabel id="type">Status</InputLabel>
                                <Select
                                    onChange={(e) => {
                                        setFilterStatus(e.target.value === '' ? '' : e.target.value)
                                    }}
                                    value={filterStatus || ""}
                                >
                                    <MenuItem value={""}>Alle</MenuItem>
                                    <MenuItem value={"created"}>Erstellt</MenuItem>
                                    <MenuItem value={"done"}>Abgeschlossen</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                        <Col md={3}>
                            <Link to={`/banking/orders/new`} className='button'>hinzufügen</Link>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row style={{ marginTop: 0 }}>
                <Col md={12}>
                    Offen: {formatMoney(orderSum)}
                </Col>
            </Row>
            <Row style={{ marginTop: 44, textAlign: 'right' }}>
            </Row>
            <Row style={{ marginTop: 0 }}>
                <Col md={12}>
                    <Table className="table_container" style={{ marginTop: 20, marginBottom: 20 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Lieferant</TableCell>
                                <TableCell>Titel</TableCell>
                                <TableCell>Betrag (brutto)</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell style={{ width: 50 }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                orders.map((order, key) => {

                                    return <TableRow key={key}>
                                        <TableCell>
                                            {order.supplier}
                                        </TableCell>
                                        <TableCell>
                                            {order.title}
                                        </TableCell>
                                        <TableCell>
                                            {formatMoney(order.sumGross)}
                                        </TableCell>
                                        <TableCell>
                                            <Select
                                                className={`statusSelect ${order.status}`}
                                                value={order.status}
                                                style={{ width: 230 }}
                                                onChange={e => updateOrderStatus(order.id, e.target.value)}
                                            >
                                                <MenuItem value={"created"}>Erstellt</MenuItem>
                                                <MenuItem value={"done"}>Abgeschlossen</MenuItem>
                                            </Select>
                                        </TableCell>
                                        <TableCell>
                                            <Link to={`/banking/orders/${order.id}`} className='link'>bearbeiten</Link>
                                        </TableCell>
                                    </TableRow>
                                })
                            }
                        </TableBody>
                    </Table>
                    <Pagination
                        pages={totalPages}
                        current={page}
                        pageChange={setPage}
                    />
                </Col>
            </Row>
        </Container>

        <Message
            open={errorMessageOpen}
            type={errorMessageType}
            small={errorMessageSmall}
            title={errorMessageTitle}
            body={errorMessageBody}
            buttonText={errorMessageButtonText}
            buttonAction={() => setErrorMessageOpen(false)}
        />

        <Loading visible={loading} />
    </>

}

export default BankingOrders;